import type { StoreActionApi } from 'react-sweet-state';
import { createStore, createHook } from 'react-sweet-state';

interface ContentTreeSelectionState {
	isMultiSelectActive: boolean;
	selectedContentIds: string[];
}

const initialState: ContentTreeSelectionState = {
	isMultiSelectActive: false,
	selectedContentIds: [],
};

const actions = {
	toggleMultiSelect:
		() =>
		({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => {
			const { isMultiSelectActive } = getState();
			setState({
				isMultiSelectActive: !isMultiSelectActive,
				// Clear selection when disabling multi-select
				selectedContentIds: isMultiSelectActive ? [] : getState().selectedContentIds,
			});
		},

	selectContent:
		(contentId: string) =>
		({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => {
			const { selectedContentIds, isMultiSelectActive } = getState();

			if (!isMultiSelectActive) {
				setState({ selectedContentIds: [contentId] });
				return;
			}

			if (!selectedContentIds.includes(contentId)) {
				setState({
					selectedContentIds: [...selectedContentIds, contentId],
				});
			}
		},

	unselectContent:
		(contentId: string) =>
		({ setState, getState }: StoreActionApi<ContentTreeSelectionState>) => {
			const { selectedContentIds } = getState();
			setState({
				selectedContentIds: selectedContentIds.filter((id) => id !== contentId),
			});
		},

	clearSelection:
		() =>
		({ setState }: StoreActionApi<ContentTreeSelectionState>) => {
			setState({
				selectedContentIds: [],
			});
		},
};

const Store = createStore<ContentTreeSelectionState, typeof actions>({
	initialState,
	actions,
	name: 'contentTreeSelection',
});

export const useContentTreeSelection = createHook(Store);
